import React from 'react'

export function NoContentMessage({ children }: { children: React.ReactNode }) {
  return <div className='c-no-content-message'>{children}</div>
}
